import { useAuth } from "#root/components/auth";
import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import RemoteCollection from "#root/utility/remote-collection";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { z } from "zod";

import PageLayout from "./layout";

const LoginListItemSchema = z.any();

const loginCollection = new RemoteCollection("/api/login", LoginListItemSchema, LoginListItemSchema);

export default function (): ReactNode {
  const navigate = useNavigate();
  const auth = useAuth();
  const handleSave = useCallback(
    ({ authToken }: { authToken?: string }) => {
      //TODO: authToken should be passed in via the row, right now it is returned in a non-conforming way
      auth.setLoginCredentials(authToken!);
      navigate("/account/profile");
    },
    [navigate, auth],
  );

  return (
    <PageLayout title="Login">
      <section
        className="flex-none m-0 flex justify-center bg-cover bg-center"
        style={{
          background:
            "linear-gradient(90deg, rgb(0 0 0 / 0.5), rgb(0 0 0 / 0.3)), url(\"/images/bg3.webp\") center / cover",
        }}
      >
        <div className="text-white w-full max-w-200 py-16">
          <h1 className="border-b-0 text-white text-4xl m-0">Welcome Back</h1>
          <p className="text-white text-xl my-[0.8rem]">Log in to your CloudQuote account</p>
        </div>
      </section>

      <section className="flex-none m-0 px-8 py-16 bg-[#f9f9fb]">
        <div className="max-w-2xl mx-auto bg-white border border-[#eee] rounded-lg shadow-[0_2px_8px_rgb(0_0_0/0.06)] p-12">
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-[#1a1a2e] m-0 mb-2">Sign in</h2>
            <p className="text-[#666] text-base m-0">Enter your credentials to access your account.</p>
          </div>
          <StandardEditor collection={loginCollection} buttonOptions={{ save: { position: "bottom", label: "Login" } }} onSave={handleSave}>
            <Fields.Set name="email">
              <label>Email Address</label>
              <Fields.Email required autoComplete="email"/>
              <Fields.Validity/>
            </Fields.Set>
            <Fields.Set name="password">
              <label htmlFor="password">Password</label>
              <Fields.Password required autoComplete="current-password"/>
              <Fields.Validity/>
            </Fields.Set>
          </StandardEditor>
        </div>
      </section>
    </PageLayout>
  );
}
